<template>
  <div>
    <vxe-grid
      ref="fabricTable"
      auto-resize
      resizable
      highlight-hover-row
      size="mini"
      :data="v_tableData"
      :columns="tableColumns"
      :height="350"
      border
      :toolbar-config="{ slots: { buttons: 'toolbar_form' } }"
      :edit-config="{ trigger: 'click', mode: 'row', enabled: !disabled }"
      @edit-closed="onEditClosed"
      :edit-rules="editRules"
    >
      <template v-slot:toolbar_form>
        <div class="d-flex">
          <div class="side-frame-success"></div>
          <div>
            <span style="font-size: 14px; color: #606266">
              {{ 'TC面料销售单明细' }}
            </span>
          </div>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import { add, multiply } from '@/libs/util.number.js'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    tcFabricPurchaseCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      v_tableData: [],
      tableColumns: tableColumns(this),
      editRules: {
        unitPrice: [
          { required: true, message: '请输入单价' },
          { type: 'number', min: 0.1, message: '请输入正确的单价' },
        ],
      },
    }
  },
  watch: {
    tableData: {
      handler(e) {
        this.v_tableData = e || []
      },
      immediate: true,
    },
  },
  methods: {
    onEditClosed({ row }) {
      if (this.disabled) return
      row.subAmount = multiply(row.unitPrice, row.qty)
      row.v_subAmount = row.subAmount.toLocaleString()
      this.subAmountChange()
    },
    subAmountChange() {
      const tableData = this.getTableData()
      const totalAmount = tableData.reduce(
        (result, next) => add(result, next['subAmount']),
        0
      )
      this.$emit('totalAmountChange', totalAmount)
    },
    async validate() {
      const result = await this.$refs.fabricTable.validate(true)
      return !result
    },
    getTableData() {
      const { fullData: tableData } = this.$refs.fabricTable.getTableData()
      return tableData || []
    },
    del({ index }) {
      this.v_tableData.splice(index, 1)
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
</style>
